import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "./AgentsDashboardProfil.css";
const AgentsDashboardProfil = ({ data = [] }) => {

    data = [
        {
            reviewer: "john@anytech365.com",
            totalReviews: 161,
            avgDailyReviewed: 7.3,
            activeDays: 22,
            avgEvalHours: 0.77,
            avgInteractionMinutes: 6.3,
            avgVoiceMinutes: 173.4,
            totalVoiceHours: 63.56
        },
        {
            reviewer: "jane@anytech365.com",
            totalReviews: 150,
            avgDailyReviewed: 6.8,
            activeDays: 22,
            avgEvalHours: 0.87,
            avgInteractionMinutes: 7.7,
            avgVoiceMinutes: 262.5,
            totalVoiceHours: 96.23
        },
        {
            reviewer: "paul@anytech365.com",
            totalReviews: 112,
            avgDailyReviewed: 6.6,
            activeDays: 17,
            avgEvalHours: 0.38,
            avgInteractionMinutes: 3.5,
            avgVoiceMinutes: 182.8,
            totalVoiceHours: 51.78
        }
    ];

    const rowData = useMemo(() => {
        return data.map((r) => ({
            reviewer: r.reviewer,
            totalReviews: r.totalReviews,
            avgDailyReviewed: r.avgDailyReviewed,
            activeDays: r.activeDays,
            avgEvalHours: r.avgEvalHours,
            avgInteractionMinutes: r.avgInteractionMinutes,
            avgVoiceMinutes: r.avgVoiceMinutes,
            totalVoiceHours: r.totalVoiceHours
        }));
    }, [data]);

    const columnDefs = useMemo(() => [
        {
            headerName: "Reviewer",
            field: "reviewer",
            flex: 1.5,
            pinned: "left"
        },
        {
            headerName: "Total Reviews",
            field: "totalReviews",
            width: 130
        },
        {
            headerName: "Avg. Daily Interactions Reviewed",
            field: "avgDailyReviewed",
            width: 200,
            valueFormatter: (p) => p.value?.toFixed(1)
        },
        {
            headerName: "Number Of Active Days",
            field: "activeDays",
            width: 180,
            valueFormatter: (p) => `${p.value} days`
        },
        {
            headerName: "Avg. Daily Evaluation Time (Hours)",
            field: "avgEvalHours",
            width: 220,
            valueFormatter: (p) => p.value?.toFixed(2)
        },
        {
            headerName: "Avg. Interaction Evaluation Time (Minutes)",
            field: "avgInteractionMinutes",
            width: 240,
            valueFormatter: (p) => p.value?.toFixed(1)
        },
        {
            headerName: "Avg. Daily Voice Interactions Duration (Minutes)",
            field: "avgVoiceMinutes",
            width: 260,
            valueFormatter: (p) => p.value?.toFixed(1)
        },
        {
            headerName: "Total Voice Interactions Duration (Hours)",
            field: "totalVoiceHours",
            width: 220,
            valueFormatter: (p) => p.value?.toFixed(2)
        }
    ], []);

    return (
        <div className="agents-dashboard-profil">
            <div className="ag-theme-alpine" style={{ width: "100%", height: "600px" }}>
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{
                        resizable: true,
                        sortable: true,
                        filter: true,
                        wrapHeaderText: true,
                        autoHeaderHeight: true
                    }}
                    pagination={true}
                    paginationPageSize={10}
                />
            </div>
        </div>
    );
};

export default AgentsDashboardProfil;